export default __webpack_public_path__ + "static/media/Iconly-Light-Delete.7ca8b2dc.svg";